import { createSelector } from 'reselect';
import { INotificationState } from './types';

const selectNotificationState = (state: { notifications: INotificationState }) => state.notifications;

export const selectNotifications = createSelector(
  selectNotificationState,
  (notificationState) => notificationState.notifications
);

export const selectUnreadCount = createSelector(
  selectNotificationState,
  (notificationState) => notificationState.unreadCount
);

export const selectNotificationLoading = createSelector(
  selectNotificationState,
  (notificationState) => notificationState.loading
);

export const selectNotificationError = createSelector(
  selectNotificationState,
  (notificationState) => notificationState.error
);

export const selectNotificationNext = createSelector(
  selectNotificationState,
  (notificationState) => notificationState.next
);
